"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import { observable, action, computed } from "mobx";
import { MenuItem } from "../../../pieces/MenuItem/MenuItem";
import * as styles from "./FolderComponent-css";
import { handleMouseUpByBlurring } from "../../../../utils";
export var FolderComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(FolderComponent, _React$Component);
  var _super = _createSuper(FolderComponent);
  function FolderComponent(props) {
    var _this;
    _classCallCheck(this, FolderComponent);
    _this = _super.call(this, props);
    _this.dragHoverCounter = 0;
    return _this;
  }
  _createClass(FolderComponent, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
        onClick = _this$props.onClick,
        disableSelect = _this$props.disableSelect;
      if (disableSelect) return;
      onClick == null ? void 0 : onClick();
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
        name = _a.name,
        icon = _a.icon,
        selected = _a.selected,
        overrideNameComponent = _a.overrideNameComponent,
        disableSelect = _a.disableSelect,
        disableDrop = _a.disableDrop,
        props = __objRest(_a, ["name", "icon", "selected", "overrideNameComponent", "disableSelect", "disableDrop"]);
      var handleClick = this.handleClick.bind(this);
      return /* @__PURE__ */React.createElement("div", {
        className: styles.container({
          draggedOver: !disableDrop && this.isDragHovering
        }),
        onDrop: this.dropHandler,
        onDragEnter: this.onDragEnter,
        onDragLeave: this.onDragLeave,
        onDragOver: function onDragOver(event) {
          event.preventDefault();
        }
      }, /* @__PURE__ */React.createElement(MenuItem, __spreadProps(__spreadValues({
        strong: true,
        truncate: true,
        startElement: icon,
        active: selected,
        disabled: disableSelect || disableDrop
      }, props), {
        onClick: handleClick,
        onMouseUp: handleMouseUpByBlurring
      }), !!overrideNameComponent ? overrideNameComponent : name));
    }
  }, {
    key: "isDragHovering",
    get: function get() {
      return this.dragHoverCounter > 0;
    }
  }, {
    key: "onDragEnter",
    value: function onDragEnter(event) {
      event.preventDefault();
      ++this.dragHoverCounter;
    }
  }, {
    key: "onDragLeave",
    value: function onDragLeave(event) {
      event.preventDefault();
      --this.dragHoverCounter;
    }
  }, {
    key: "dropHandler",
    value: function dropHandler(event) {
      event.preventDefault();
      this.dragHoverCounter = 0;
      var _this$props2 = this.props,
        onDrop = _this$props2.onDrop,
        disableDrop = _this$props2.disableDrop;
      if (!!onDrop && !disableDrop) {
        onDrop(event);
      }
    }
  }]);
  return FolderComponent;
}(React.Component);
FolderComponent.defaultProps = {
  element: "button",
  hasMenuOption: false,
  disableSelect: false,
  disableDrop: false
};
__decorateClass([observable.ref], FolderComponent.prototype, "dragHoverCounter", 2);
__decorateClass([computed], FolderComponent.prototype, "isDragHovering", 1);
__decorateClass([action.bound], FolderComponent.prototype, "onDragEnter", 1);
__decorateClass([action.bound], FolderComponent.prototype, "onDragLeave", 1);
__decorateClass([action.bound], FolderComponent.prototype, "dropHandler", 1);
FolderComponent = __decorateClass([observer], FolderComponent);